export default {
    whyTitle:"Why choose Linguascore?",
    whyFeaturesTitle1: "Aligned with real Exams",
    whyFeaturesDescription1: "Our content is designed to match the format, duration and difficulty of official IELTS, TOEFL and TCF Exams so you're ready for test day.",
    whyFeaturesTitle2: "Smart technology",
    whyFeaturesDescription2: "We analyse your performance in real time and suggest exercises tailored to your level to help you progress faster.",
    whyFeaturesTitle3: "Complete toolkit",
    whyFeaturesDescription3: "From theory to practice: study notes, targeted exercises, full-length mock tests and detailed performance analytics.",
    whyFeaturesTitle4: "Real exam conditions",
    whyFeaturesDescription4: "Our mock tests replicate the official test format and timing so you can practise under exam-like conditions.",
    examTitle:"Exams we prepare you for",
    pricingTitle:"Simple, transparent pricing",
    pricingDescription:"Choose the plan that fits your goals. Full access to mock tests, resources and progress tracking.",
    pricingFooterCallToActionText:"All plans include a satisfaction guarantee. Need help?",
    pricingFooterCallToActionLabel:"Contact us.",
    viewPricingActionButtonLabel:"View pricing",
    viewFullPricingActionButtonLabel:"View full pricing",
    trustBadgeTitle1: "Satisfaction guarantee",
    trustBadgeSubtitle1: "Learn with confidence",
    trustBadgeTitle2: "Learn with confidence",
    trustBadgeSubtitle2: "Study from anywhere",
    trustBadgeTitle3: "Extended access",
    trustBadgeSubtitle3: "3 months access included",
    testimonialTitle:"What our users say",
    testimonialQuote1: "The mock tests and analytics helped me understand my weak points. I improved my IELTS score significantly.",
    testimonialAuthor1: "Sarah, Linguascore user",
    testimonialQuote2: "Clear structure, realistic exercises and progress tracking. Exactly what I needed for TCF Canada.",
    testimonialAuthor2: "Marc, Linguascore user",
    testimonialQuote3: "I liked the mix of practice tests and resources. The platform felt aligned with the real exam.",
    testimonialAuthor3: "Alex, Linguascore user",
    faqTitle:"Frequently asked questions",
    faqQuestion1: "What is Linguascore and how does it work?",
    faqAnswer1: "Linguascore is an online platform for language test preparation. Once registered, you get access to a structured path with mock tests, practice exercises, resources and progress tracking for IELTS, TOEFL, TCF France and TCF Canada.",
    faqQuestion2: "How is Linguascore different from other prep tools?",
    faqAnswer2: "Our paths are built for each exam with targeted content, realistic practice, instant feedback and analytics. You can take full-length mock tests and track your progress over time.",
    faqQuestion3: "How can I track my progress?",
    faqAnswer3: "Your dashboard shows total tests, study time and average scores. The Results section lists all your test results with detailed feedback so you can see your strengths and areas to improve.",
}